//Models
PJQ.models.groups = {};

PJQ.models.groups.Group = PJQ.models.BaseModel.extend({
	idAttribute: "groupId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'groups',
				value: this.id
			}
		])
	}
});

//Collections
PJQ.collections.groups = {};

PJQ.collections.groups.Groups = PJQ.collections.BaseCollection.extend({
	defaults: {
		groupLevels: 1
	},
	model: PJQ.models.groups.Group,
	endpoint: function () {
		let endpoint = [
			{
				endpoint: 'groups'
			}
		];
		if (this.options.userId > 0) {
			endpoint = [
				{
					endpoint: 'users',
					value: this.options.userId
				},
				{
					endpoint: 'groups'
				}
			];
		}
		else if (this.options.project != null) {
			endpoint = [
				{
					endpoint: 'projects',
					value: this.options.project.id
				},
				{
					endpoint: 'groups'
				}
			];
		}
		return PJQ.helpers.urlHelpers.generateEndpoint(endpoint);
	},
	afterInit: function () {
		this.on('sync', this.setSelectedGroups, this);
	},
	setSelectedGroups: function (selectedGroupIds) {
		if (_.size(this.models) > 0) {
			_.each(this.models, _.bind(function (model) {
				if (selectedGroupIds != null) {
					if (selectedGroupIds.indexOf(model.id) !== -1) {
						model.set('isSelected', true);
					}
					else {
						model.set('isSelected', false);
					}
				}
				else {
					model.set('isSelected', false);
				}

			}, this));
		}
	},
	addSelectedGroups: function (selectedGroupIds) {
		_.each(typeof selectedGroupIds === "number" ? [selectedGroupIds] : selectedGroupIds, function (groupId) {
			let group = this.get(groupId);
			if (group != null) {
				group.set('isSelected', true);
			}
		}, this);
	},
	deleteSelectedGroups: function (selectedGroupIds) {
		_.each(typeof selectedGroupIds === "number" ? [selectedGroupIds] : selectedGroupIds, function (groupId) {
			let group = this.get(groupId);
			if (group != null) {
				group.set('isSelected', false);
			}
		}, this);
	},
	setDisabledGroups: function (disabledGroupIds) {
		if (_.size(this.models) > 0) {
			_.each(this.models, _.bind(function (model) {
				if (disabledGroupIds.indexOf(model.id) !== -1)
					model.set('isDisabled', true);
				else
					model.set('isDisabled', false);
			}, this));
		}
	},
	setPublicDisabledGroups: function (disabledPublicGroupIds = []) {
		if (_.size(this.models) > 0) {
			_.each(this.models, _.bind(function (model) {
				if (disabledPublicGroupIds.indexOf(model.id) !== -1) {
					model.set('isDisabled', true);
					model.set('isPublic', true);
				}
				else {
					model.set('isDisabled', false);
					model.set('isPublic', false);
				}
			}, this));
		}
	},
	getGroupIds: function () {
		let groupIds = [];
		_.each(this.models, function (model) {
			groupIds.push(model.id);
		});
		return groupIds;
	},
	getSelectedGroups: function () {
		let selectedGroups = new PJQ.collections.groups.Groups([], {
			groupLevels: this.options.groupLevels ? this.options.groupLevels : PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
		});
		_.each(this.models, function (model) {
			if (model.get('isSelected'))
				selectedGroups.add(model);
		});
		return selectedGroups;
	},
	getGroupsLeveled: function (filterGroups) {
		let result = null;
		if (this.options.groupLevels === 1) {
			result = (filterGroups == null ? this.models : _.filter(this.models, function (model) {
				return _.find(filterGroups, {id: model.id}) != null;
			}));
		}
		else if (this.options.groupLevels > 1) {
			result = [];
			_.each(this.models, function (model) {
				if (filterGroups === null || _.find(filterGroups, {id: model.id}) != null) {
					let parentName1 = model.get('groupDescription'),
						parentName2 = '';
					if (_.size(parentName1) === 0) {
						parentName1 = "No Parent";
					}
					if (this.options.groupLevels === 3) {
						parentName2 = parentName1.split('|')[1];
						parentName1 = parentName1.split('|')[0];

						if (_.size(parentName2) === 0) {
							parentName2 = "No Parent";
						}
					}

					let existingParent1 = _.find(result, function (group) {
						return group.name === parentName1;
					});
					if (existingParent1 != null) {
						if (this.options.groupLevels === 3) {
							let existingParent2 = _.find(existingParent1.parents, function (parent) {
								return parent.name === parentName2;
							});
							if (existingParent2 != null) {
								existingParent2.groups.push(model);
							}
							else {
								existingParent1.parents.push({
									name: parentName2,
									groups: [model]
								});
							}
						}
						else {
							existingParent1.groups.push(model);
						}
					}
					else {
						if (this.options.groupLevels === 3) {
							result.push({
								name: parentName1,
								parents: [
									{
										name: parentName2,
										groups: [model]
									}
								]
							});
						}
						else {
							result.push({
								name: parentName1,
								groups: [model]
							});
						}
					}
				}
			}, this);
		}
		return result;
	}
});

//Views
PJQ.views.groups = {};

PJQ.views.groups.GroupSelector = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Group-Selector-Container'),
		subTemplates: {
			selector: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Group-Selector')
		},
		groups: null,
		groupLabel: null,
		groupUserId: null,
		groupLevels: null,
		detectGroupLevels: false,
		includeGroupIds: null,
		selectedGroupIds: null,
		disabledGroupIds: null,
		selectedGroups: null,
		onGroupsLoaded: null,
		onGroupSelected: null,
		isAdmin: false,
		isPublicGroups: false,
		isEnableSelectedFilter: true,
		isEnableSelectAll: true,
		isDisableSelected: false,
		isHideDisabled: false,
		isExpandSelected: true,
		isDisableParents: false,
		isDisableCollapsedParents: false,
		isShowGroupCount: false,
		canEdit: true,
		isShowNoGroup: false,
		onSelect: _.noop,
		isSingleChoice: false,
		maxGroups: null,
		headerButtons: null
	},
	events: {
		"keyup .group-search": "renderGroups",
		"click .btn-header-action": "headerAction",
		"click .group-clear-filters": "clearFilters",
		"click .group-all-select": "selectAll",
		"click .group-parent-select": "selectParent",
		"click .group-select": "groupSelected",
		"click .group-expand": "expandParentClick",
		"click .report-contact-groups": "reportContactGroups",
		"click .no-group-select": "noGroupClicked"
	},
	beforeFirstRender: function () {
		if (this.options.maxGroups > 0) {
			this.options.isEnableSelectAll = true;
			this.options.isDisableParents = true;
		}
	},
	afterRender: function () {
		this.isNoGroupSelected = false;
		this.options.groupUserId = this.options.isPublicGroups ? PJQ.constants.publicUserId : this.options.groupUserId;
		if (this.options.groups == null) {
			this.getGroups();
		}
		else {
			this.afterSync();
		}
	},
	reload: function (userId) {
		if (typeof userId === 'number') {
			this.options.groupUserId = userId;
		}
		this.getGroups();
	},
	getGroups: function () {
		PJQ.app.session.fetchUserGroups(this.options.groupUserId, _.bind(function (groups) {
			this.options.groups = groups.toJSON();
			this.afterSync();
		}, this));
	},
	afterSync: function () {
		this.options.isGroupsLoaded = true;
		this.loadGroups();
	},
	loadGroups: function () {
		if (this.removed) {
			return;
		}

		let groups = this.options.groups != null ? this.options.groups : PJQ.app.session.groups[this.options.groupUserId > 0 ? this.options.groupUserId : -1].toJSON();
		if (this.options.groupUserId === PJQ.constants.publicUserId) {
			this.options.groupLevels = 2;
		}
		else if (this.options.detectGroupLevels) {
			for (let i = 0; i < _.size(groups); i++) {
				let group = groups[i];
				if (_.size(group.groupDescription) > 0) {
					if (group.groupDescription.indexOf('|') !== -1) {
						// this group has a pipe, it is group level 3
						this.options.groupLevels = 3;
						break;
					}
					else if (this.options.groupLevels < 2) {
						// this group has a description, it is at least group level 2
						// we need to keep checking other groups to make sure its not group level 3
						this.options.groupLevels = 2;
					}
				}
			}
			_.each(groups, _.bind(function (group) {

			}, this));
		}
		else if (this.options.groupLevels == null) {
			let groupLevels = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS);
			this.options.groupLevels = groupLevels ? groupLevels : 1;
		}

		if (this.options.groupLabel == null) {
			let groupLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL);
			this.options.groupLabel = typeof groupLabel === 'string' ? groupLabel.toLowerCase() : 'trades';
		}

		this.collection = new PJQ.collections.groups.Groups(groups, {
			groupLevels: this.options.groupLevels,
			userId: this.options.groupUserId
		});

		if (_.size(this.options.selectedGroupIds) > 0) {
			//if init with selectedGroupIds, just set those groups as selected
			this.collection.setSelectedGroups(this.options.selectedGroupIds);
		}
		else {
			//Else if init with selectedGroups, loop through them and set selected by groupId
			//Also set disabled accordingly
			// This is used to disable groups related to public contacts when admins are editing
			this.disabledPublicGroups = [];
			let selectedGroupIds = [];
			if (_.size(this.options.selectedGroups) > 0) {
				_.each(this.options.selectedGroups.models, function (group) {
					selectedGroupIds.push(group.id);

					//Custom functionality for public groups on contacts - only when admin is editing
					//This piggybacks off of disabledGroupIds for disabling checkboxes
					if (this.options.isAdmin && group.get('isPublic') && PJQ.app.session.get('masterUserId') !== 23) {
						this.disabledPublicGroups.push(group.id);
					}
				}, this);
			}
			this.collection.setSelectedGroups(selectedGroupIds);
		}

		//If editing is disabled, disable all group checkboxes
		if (!this.options.canEdit) {
			this.collection.setDisabledGroups(_.map(this.collection.models, function (model) {
				return model.id;
			}));
		}
		else if (this.options.contactId > 0 && _.size(this.disabledPublicGroups) > 0) {
			this.createDisabledPublicGroupsAlert();
			this.collection.setPublicDisabledGroups(this.disabledPublicGroups);
		}

		//If there are disabledGroupIds passed in, mirror that to this.collection
		//These will render as disabled
		if (_.size(this.options.disabledGroupIds) > 0) {
			this.collection.setDisabledGroups(this.options.disabledGroupIds);
		}
		this.originalGroups = this.collection.getSelectedGroups().models;

		this.renderFilters();
		this.renderGroups();

		if (_.size(this.options.selectedGroupIds) > 0 && this.options.isShowNoGroup && this.options.selectedGroupIds.indexOf(0) !== -1)
			this.$('.no-group-select').prop('checked', true);

		if (typeof this.options.onGroupsLoaded === 'function') {
			this.options.onGroupsLoaded();
		}
	},
	renderFilters: function () {
		if (_.size(this.disabledPublicGroups) > 0) {
			this.$('.group-status-filter').append('<option value="public">Public</option>');
		}
		if (this.options.isEnableSelectedFilter) {
			this.filterPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.group-status-filter'),
				onChange: _.bind(this.renderGroups, this),
				noneSelectedText: 'No Filters',
				hideDisabled: false
			});
		}
	},
	renderGroups: function () {
		let searchFilter = this.$('.group-search').val().toLowerCase(),
			filterVal = this.options.isEnableSelectedFilter ? this.filterPicker.getValue().toLowerCase() : '',
			selectedFilter = null,
			publicFilter = null,
			groups = [];

		if (filterVal.toLowerCase() === 'public') {
			publicFilter = true;
		}
		else if (filterVal.toLowerCase() === 'selected') {
			selectedFilter = true;
		}
		else if (filterVal.toLowerCase() === 'unselected') {
			selectedFilter = false;
		}
		if (_.size(searchFilter) > 0 || selectedFilter != null || publicFilter != null || _.size(this.options.includeGroupIds) > 0) {
			this.$('.group-clear-filters').prop('disabled', false);
			_.each(this.collection.models, _.bind(function (model) {
				if (_.size(this.options.includeGroupIds) === 0 || this.options.includeGroupIds.indexOf(model.id) !== -1) {
					if ((publicFilter == null || model.get('isPublic') === publicFilter) && (selectedFilter === null || model.get('isSelected') === selectedFilter) && ((model.get('groupName').toLowerCase().indexOf(searchFilter) > -1) || (model.get('groupDescription').toLowerCase().indexOf(searchFilter) > -1)))
						groups.push(model);
				}
			}, this));
		}
		else {
			this.$('.group-clear-filters').prop('disabled', true);
			groups = this.collection.models;
		}

		let data = {
			models: this.collection.getGroupsLeveled(groups),
			options: this.options,
			isNoGroupSelected: this.isNoGroupSelected
		};
		this.renderSubTemplate(false, this.options.subTemplates.selector, this.$('.groups-container'), data, _.bind(function () {
			this.setSelectedParents();
			if (!this.isRendered && this.options.groupLevels > 1 && this.options.isExpandSelected) {
				this.expandSelectedParents();
			}
			this.setDisabledParents();
			if (this.options.isHideDisabled) {
				this.$('.group-select:disabled').closest('.group-select-container').hide();
			}
			this.isRendered = true;

			this.checkMaxGroups();
		}, this));
	},
	setDisabledParents: function () {
		let self = this;
		this.$('.group-parent-select').each(function () {
			//Disable the parent if:
			//isDisableCollapsedParents == true and there are no visible groups within the corresponding child container (shown group parents do not qualify)
			//or
			//there are no enabled groups shown within the corresponding child container
			let childContainer = self.getParentChildContainer($(this));
			$(this).prop('disabled', (self.options.isDisableCollapsedParents && (childContainer.hasClass('hidden') || _.size(childContainer.find('.group-child-container.hidden')) > 0)) || _.size(childContainer.find('.group-select,.group-parent-select').not(':disabled')) === 0);
		});
		if (this.options.isEnableSelectAll && !this.options.isDisableCollapsedParents && !this.options.isDisableParents) {
			this.$('.group-all-select').prop('disabled', !(this.$('.group-select:not(:disabled)').length > 0));
		}
	},
	setSelectedParents: function () {
		let self = this;
		this.$('.group-parent-select').each(function () {
			$(this).prop('checked', _.size(self.getParentChildContainer($(this)).find('.group-select').not(':checked')) === 0);
		});
		this.$('.group-all-select').prop('checked', !(this.$('.group-select:not(:checked)').length > 0));
	},
	createDisabledPublicGroupsAlert: function () {
		new PJQ.Alert(this.$el, {
			text: "<div>This contact has " + this.options.groupLabel.toLowerCase() + " that are linked to a public account.  They can only be removed by this contact.</div><div class='mt-1'>Think these are incorrect?  <a href='javascript:void(0)' class='report-contact-groups font-weight-normal'>Report their groups</a></div>",
			isPrepend: true
		});
	},
	getGroupSwitch: function (groupId) {
		return this.$('input[data-group-id="' + groupId.toString() + '"]');
	},
	expandSelectedParents: function () {
		if (this.options.groupLevels > 1) {
			_.each(this.collection.getSelectedGroups().models, function (group) {
				let childContainer = this.getGroupSwitch(group.id).closest('.group-child-container');
				if (childContainer.hasClass('hidden')) {
					this.expandParent(childContainer);
				}
				if (this.options.groupLevels === 3) {
					childContainer = childContainer.parent().closest('.group-child-container');
					if (childContainer.hasClass('hidden')) {
						this.expandParent(childContainer);
					}
				}
			}, this);
		}
	},
	getParentChildContainer: function (parent) {
		return parent.closest('.pretty').siblings('.group-child-container');
	},
	setIncludedGroups: function (includeGroupIds) {
		this.options.includeGroupIds = includeGroupIds;
		this.renderGroups();
	},
	headerAction: function (e) {
		let actionId = $(e.currentTarget).data('id'),
			headerButton = _.findWhere(this.options.headerButtons, {id: actionId});

		if (headerButton != null && typeof headerButton.callback === 'function') {
			headerButton.callback(this);
		}
	},
	clearFilters: function () {
		this.$('.group-search').val('');
		if (this.options.isEnableSelectedFilter) {
			this.filterPicker.deselectAll();
		}
		this.renderGroups();
	},
	selectAll: function (override) {
		if (typeof override === 'boolean')
			this.$('.group-all-select').prop('checked', override);

		let groupSelects = this.$('.group-select:not(:disabled)');
		if (this.$('.group-all-select').prop('checked')) {
			this.isNoGroupSelected = true;
			this.collection.addSelectedGroups(_.map(groupSelects, function (select) {
				return $(select).data('groupId');
			}));
			groupSelects.prop('checked', true);
		}
		else {
			this.isNoGroupSelected = false;
			this.collection.deleteSelectedGroups(_.map(groupSelects, function (select) {
				return $(select).data('groupId');
			}));
			groupSelects.prop('checked', false);
		}
		this.onGroupSelected();
	},
	noGroupClicked: function (e) {
		this.isNoGroupSelected = this.$('.no-group-select').prop('checked');
	},
	selectParent: function (e) {
		if (!this.options.isDisableParents) {
			//Select all child groups/parents that aren't disabled
			let childContainer = this.getParentChildContainer($(e.currentTarget)),
				isChecked = $(e.currentTarget).is(':checked');

			//If only un-collapsed parents can be selected, ensure we only select visible groups
			//This mainly only matters for groupLevels == 3, but it doesn't hurt to do for all levels
			let groupSelects = [];
			if (this.options.isDisableCollapsedParents) {
				groupSelects = childContainer.find('.group-select:visible').not(':disabled');
				childContainer.find('.group-select:visible,.group-parent-select:visible').not(':disabled').prop('checked', isChecked);
			}
			else {
				groupSelects = childContainer.find('.group-select').not(':disabled');
				childContainer.find('.group-select,.group-parent-select').not(':disabled').prop('checked', isChecked);
			}

			if (isChecked) {
				//If its checked, expand the parents/sub-parents to show the groups that were selected
				if (childContainer.hasClass('hidden')) {
					this.expandParent(childContainer);
				}
				//Check if there is another level underneath the first one to expand
				childContainer = childContainer.find('.group-child-container');
				if (_.size(childContainer) > 0) {
					if (childContainer.hasClass('hidden')) {
						this.expandParent(childContainer);
					}
				}
				this.collection.addSelectedGroups(_.map(groupSelects, function (select) {
					return $(select).data('groupId');
				}));
			}
			else {
				this.collection.deleteSelectedGroups(_.map(groupSelects, function (select) {
					return $(select).data('groupId');
				}));
			}
			this.onGroupSelected();
		}
	},
	selectGroups: function (groupIds) {
		if (this.options.canEdit && _.size(groupIds) > 0) {
			_.each(groupIds, function (groupId) {
				this.selectGroup(groupId, true, true, true);
			}, this);
			this.options.onSelect();
			this.onGroupSelected();
		}
	},
	groupSelected: function (e) {
		if (this.options.canEdit) {
			let select = $(e.currentTarget),
				groupId = select.data('groupId'),
				isSelected = select.is(':checked');
			this.selectGroup(groupId, isSelected, false);
		}
	},
	selectGroup: function (groupId, isSelected, setSwitch = false, silent = false) {
		if (this.options.canEdit && groupId > 0) {
			if (isSelected) {
				if (this.options.isSingleChoice) {
					this.collection.setSelectedGroups();
				}
				this.collection.addSelectedGroups(groupId);
			}
			else {
				this.collection.deleteSelectedGroups(groupId);
			}

			if (setSwitch) {
				this.getGroupSwitch(groupId).prop('checked', isSelected);
			}

			if (!silent) {
				this.options.onSelect();
				this.onGroupSelected();
			}
		}
	},
	onGroupSelected: function () {
		this.checkMaxGroups();
		this.setSelectedParents();
		if (typeof this.options.onGroupSelected === 'function') {
			this.options.onGroupSelected(this.getGroupsData());
		}
	},
	checkMaxGroups: function () {
		if (this.options.maxGroups == null) {
			return true;
		}

		let result = this.options.maxGroups <= this.getGroupsData().selected.length;
		if (result) {
			_.each((this.$('.group-select:not(:disabled)') && this.$('.group-select:not(:checked)')), function (group) {
				$(group).prop('disabled', true);
			})
		}
		else if(this.options.canEdit) {
			_.each(this.$('.group-select:disabled'), function (group) {
				$(group).prop('disabled', false);
			})
		}
		return result;
	},
	expandParentClick: function (e) {
		this.expandParent($(e.currentTarget).siblings('.group-child-container'));
	},
	expandParent: function (container) {
		let icon = container.siblings('i.group-expand');
		if (container.hasClass('hidden')) {
			container.removeClass('hidden');
			icon.removeClass('fa-chevron-down text-primary');
			icon.addClass('fa-chevron-up text-muted');
		}
		else {
			//If its being collapsed, find all sub-parents and collapse those as well
			container = container.add(container.find('.group-child-container'));
			icon = icon.add(container.find('i.group-expand'));
			container.addClass('hidden');
			icon.removeClass('fa-chevron-up text-muted');
			icon.addClass('fa-chevron-down text-primary');
		}
		this.setDisabledParents();
	},
	getGroupsData: function () {
		let selectedGroups = this.collection.getSelectedGroups().models;
		if (this.options.isSingleChoice) {
			return _.size(selectedGroups) > 0 ? selectedGroups[0] : null;
		}
		else {
			if (this.options.isShowNoGroup && this.$('.no-group-select').prop('checked')) {
				selectedGroups.push(new PJQ.models.groups.Group({
					groupId: 0
				}));
			}

			let newGroups = _.filter(selectedGroups, function (group) {
					return !_.findWhere(this.originalGroups, {id: group.id});
				}, this),
				allGroups = _.union([], this.originalGroups);

			_.each(selectedGroups, function (group) {
				if (!_.findWhere(allGroups, {id: group.id}))
					allGroups.push(group);
			});
			_.each(allGroups, _.bind(function (group) {
				if (_.findWhere(this.originalGroups, {id: group.id}) && !_.findWhere(selectedGroups, {id: group.id}))
					group.set('isDeleted', true);
				else
					group.set('isDeleted', false);
			}, this));
			if (this.options.isSync) {
				this.originalGroups = selectedGroups;
			}
			return {
				selected: selectedGroups,
				new: newGroups,
				original: this.originalGroups,
				all: allGroups
			};
		}
	},
	reportContactGroups: function () {
		new PJQ.views.groups.ReportContactGroupsModal({
			contactId: this.options.contactId,
			groups: this.collection
		});
	},
	showError: function (errorText) {
		this.hideError();
		this.errorAlert = new PJQ.Alert(this.$el, {
			type: 'danger',
			extraClasses: ['mt-1, mb-1'],
			text: errorText,
			isPrepend: true
		});
	},
	hideError: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
	},
	remove: function () {
		this.removed = true;
		return PJQ.views.BaseView.prototype.remove.call(this);
	}
});

PJQ.views.groups.ReportContactGroupsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Report-Contact-Groups'),
		onSave: _.noop
	},
	events: {
		"click .btn-report-contact-groups": "report"
	},
	afterRender: function () {
		let grps = _.where(this.options.groups.getSelectedGroups().toJSON(), {isPublic: true});
		_.each(grps, function (grp) {
			grp.isDisabled = false;
		});
		this.groupSelector = new PJQ.views.groups.GroupSelector({
			el: this.$('.group-selector'),
			groups: grps,
			isEnableSelectedFilter: false,
			onGroupSelected: _.bind(this.checkGroupsSelected, this)
		});
		this.checkGroupsSelected(this.groupSelector.getGroupsData());
	},
	checkGroupsSelected: function (groupsData) {
		this.$('.btn-report-contact-groups').prop('disabled', _.size(groupsData.selected) === 0)
	},
	report: function () {
		let reportedGroups = new PJQ.collections.groups.Groups(this.groupSelector.getGroupsData().selected).toJSON();
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.options.contactId
				},
				{
					endpoint: 'groups'
				},
				{
					endpoint: 'report'
				}
			]),
			data: {
				groups: reportedGroups,
				projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null
			}
		}).post().done(_.bind(function () {
			let reportedGroupCount = _.size(reportedGroups),
				modalCreated = PJQ.notifications.createNotifyModal({
					header: 'Groups Reported',
					notification: reportedGroupCount.toString() + " groups linked to this contact's public account were successfully reported.  Customer service will determine if they are valid.",
					cookie: PJQ.constants.cookies.NOTIFY_CONTACT_GROUPS_REPORTED
				});
			if (!modalCreated) {
				PJQ.notifications.notify.successNotify({
					message: reportedGroupCount.toString() + ' groups successfully reported.'
				});
			}
		}, this)).fail(function () {
			PJQ.notifications.notify.errorNotify({
				message: 'Failed to report groups.  Contact customer service.'
			});
		});
	}
});


PJQ.views.groups.SelectGroupsModal = PJQ.views.BaseModal.extend({
	defaults: {
		isSingleChoice: false,
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Groups-Select'),
		alertText: null,
		onSave: null
	},
	events: {
		"click .groups-select-save": "onSave"
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		this.options.selectorOptions = _.defaults(this.options.selectorOptions, {
			el: this.$('.group-selector'),
			isEnableSelectedFilter: false,
			onGroupSelected: _.bind(this.checkGroupsSelected, this),
		});
		this.groupSelector = new PJQ.views.groups.GroupSelector(this.options.selectorOptions);
	},
	checkGroupsSelected: function (groupsData) {
		this.$('.groups-select-save').prop('disabled', _.size(groupsData.new) === 0 && _.size(_.difference(_.map(groupsData.original, function (group) {
			return group.id;
		}), _.map(groupsData.selected, function (group) {
			return group.id
		}))) === 0);
		if (this.options.selectorOptions.isSingleChoice) {
			this.onSave()
		}
	},
	onSave: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.groupSelector.getGroupsData());
		}
		this.removeModal();
	},
});

PJQ.views.groups.GroupsSelectInput = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Groups-Select-Input'),
		subTemplates: {
			groupBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Groups-Select-Input-Groups')
		},
		selectedGroups: null,
		isShowAddButton: true,
		addButton: null,
		isReadOnly: false,
		onAfterSave: _.noop,
		limitGroups: false
	},
	events: {
		"click .group-select-input-edit": "modify",
		"click .group-select-input-delete": "deleteGroup",
		"click .btn-show-groups": "showAllGroups"
	},
	renderData: function () {
		return {
			isReadOnly: this.options.isReadOnly
		};
	},
	beforeRender() {
		if (!this.options.isShowAddButton) {
			this.options.template = new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Groups-Select-Input-No-Button');

			if (_.size(this.options.addButton) > 0) {
				this.options.addButton.on('click', _.bind(this.modify, this));
			}
		}

		this.selectedGroups = this.options.selectedGroups ? this.options.selectedGroups : [];
	},
	afterRender() {
		this.renderSelectedGroups();
	},
	deleteGroup: function () {
		let id = jQuery(event.target).closest('.select-group-container').data('group-id');

		this.selectedGroups = _(this.selectedGroups).filter(function (item) {
			return item.id !== id;
		});

		this.options.onAfterSave(this.selectedGroups);

		this.renderSelectedGroups();
	},
	modify: function () {
		this.selector = new PJQ.views.groups.SelectGroupsModal({
			selectorOptions: {
				groupUserId: this.options.groupUserId,
				selectedGroupIds: _.map(this.selectedGroups, function (model) {
					return model.attributes.groupId
				}),
				groupLevels: this.options.groupLevels,
			},
			onSave: _.bind(function (data) {
				this.selectedGroups = _.union(this.selectedGroups, data.new);
				this.renderSelectedGroups();
				this.options.onAfterSave(this.selectedGroups);
			}, this)
		});
	},
	renderSelectedGroups: function () {
		let data;
		if (this.options.limitGroups && _.size(this.selectedGroups) > 5) {
			data = _.rest(this.selectedGroups.reverse(), _.size(this.selectedGroups) - 5).reverse();
		}
		else {
			data = this.selectedGroups;
		}

		if (_.size(data) === 0) {
			this.$('.group-select-list').html('<div class="text-muted font-weight-light fs-16 mb-2 mt-2">No Trades Selected</div>');
		}
		else {
			this.renderSubTemplate(false, this.options.subTemplates.groupBadge, this.$('.group-select-list'),
				{
					models: data,
					isReadOnly: this.options.isReadOnly
				});
		}

		if (this.options.limitGroups && _.size(this.selectedGroups) > 5) {
			this.$('.group-select-list').append("<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> Show " + (_.size(this.selectedGroups) - 5) + " more item(s)</a>")
		}
	},
	showAllGroups: function () {
		let data = this.selectedGroups.reverse();

		if (_.size(data) === 0) {
			this.$('.group-select-list').html('<div class="text-muted font-weight-light fs-16 mb-2">No Trades Selected</div>');
		}
		else {
			this.renderSubTemplate(false, this.options.subTemplates.groupBadge, this.$('.group-select-list'),
				{
					models: data,
					isReadOnly: this.options.isReadOnly
				});
		}
	}
});
